import {useState, useEffect} from "../../../__snowpack__/pkg/react.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
export const useWarehouseList = (params) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async () => {
    setLoading(true);
    try {
      const isFulfillment = params && !!params.isFulfillment || false;
      const {data: data2} = await axios.get(`/saas/warehouses/list/enabled/brief/${isFulfillment}`);
      setData(data2 || []);
      return data2;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return {
    loading,
    data,
    fetchData
  };
};
export const useWarehouseListNew = (params) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchData = async (params2) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.post(`/saas/warehouses/list`, params2);
      setData(data2 || []);
      return data2;
    } catch (error) {
      handleError(error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData({warehouseType: "MY_WAREHOUSE", status: "ENABLE"});
  }, []);
  return {
    loading,
    data,
    fetchData
  };
};
